import { Controller } from "@hotwired/stimulus"
import { getStorage, setStorage } from "../instrument_take/helpers/storage.js"

const STORAGE_KEY = "cookie_consent_accepted"
const ACCEPTED_EVENT = "cookie-consent:accepted"

export default class extends Controller {
  connect() {
    if (getStorage(STORAGE_KEY)) {
      this.hide()
    }
  }

  accept() {
    setStorage(STORAGE_KEY, "true")
    document.dispatchEvent(new CustomEvent(ACCEPTED_EVENT))
    this.hide()
  }

  hide() {
    this.element.remove()
  }
}
